import { createStyleSheet } from '@shared-ui/theme'
import { rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  button: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: rw(8),
    justifyContent: 'center',
    overflow: 'hidden',
    paddingHorizontal: rw(20),
    borderRadius: rw(theme.SIZE_BUTTON_BORDER_RADIUS),
  },
  compact: { gap: rw(4), paddingHorizontal: rw(16) },
  small: { paddingHorizontal: rw(12) },
  label: {
    color: theme.COLOR_TEXT_INVERSE_PRIMARY,
    flexShrink: 1,
  },
}))
